import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { anularVaciado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionEliminarVaciadoView } from '../components/OperacionEliminarVaciadoView'

export const OperacionEliminarVaciado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionEliminarVaciadoView
        silo={silo}
        aceptar={async () => {
          try {
            await anularVaciado(silo)
            closeDialog()
            enqueueSnackbar('Anulado de vaciado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Anulado de vaciado incorrecto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('ANULAR_VACIADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
